// [display label, location name returned by total-stock-availability]. This
// mirrors the Total Stock location groups so the Orders hover shows the same
// regional availability without changing Total Stock itself.
export const REGION_COLUMNS = {
  AU: [
    ['EWE - Melbourne', 'EWE'],
    ['EWE - Sydney', 'EWE - Sydney'],
    ['EWE - Brisbane', 'EWE - Brisbane'],
    ['EWE - Perth', 'EWE - Perth'],
    ['EWE - Adelaide', 'EWE - Adelaide'],
    ['HQ2', 'HQ2'],
    ['QV Store', 'QV Store'],
    ['Chadstone', 'CHDRETAIL'],
    ['Highpoint', 'Highpoint'],
    ['Emporium', 'Emporium'],
    ['Doncaster', 'Doncaster'],
    ['Burnside', 'Burnside'],
    ['Canberra', 'Canberra'],
    ['Chatswood', 'Chatswood'],
    ['Galeries Store', 'Galeries Sydney'],
    ['Pitt St', 'Pitt Street'],
    ['Bondi', 'Bondi'],
    ['Rosebery', 'Rosebery'],
    ['James St', 'James St'],
    ['Karrinyup', 'Karrinyup'],
    ['Airport Sydney', 'Airport Sydney'],
  ],
  US: [
    ['GREEEN ST', 'NYC Greene St'],
    ['UNIS', 'UNIS'],
    ['KENTUCKY', 'LCHKTC'],
    ['UTAH', 'LCHSLC'],
    ['AMAZON', 'Amazon'],
  ],
  UK: [
    ['Airbox', 'Airbox UK'],
    ['Amazon UK', 'Amazon UK'],
  ],
  NZ: [
    ['EWE - New Zealand', 'EWE - New Zealand'],
  ],
};

// A cell is a bare number when everything on hand is available, and an object
// when reserved, display, quarantine or damaged stock is present. Only reserved
// is deducted; quarantine and damaged are separate from on hand.
export const cellAvailable = (cell) => (
  typeof cell === 'number' ? cell : (cell?.a ?? 0)
);

export const regionTotals = (row, region) => (
  (REGION_COLUMNS[region] || []).reduce((totals, [, locationName]) => {
    const cell = row?.cells?.[locationName];
    if (cell === undefined || cell === null) return totals;
    if (typeof cell === 'number') {
      return { ...totals, available: totals.available + cell, onHand: totals.onHand + cell };
    }
    return {
      available: totals.available + (cell.a || 0),
      onHand: totals.onHand + (cell.o || 0),
      reserved: totals.reserved + (cell.r || 0),
      quarantine: totals.quarantine + (cell.q || 0),
      damaged: totals.damaged + (cell.d || 0),
    };
  }, { available: 0, onHand: 0, reserved: 0, quarantine: 0, damaged: 0 })
);

export const unallocatedFor = (row, region) => row?.unallocated?.[region] || 0;
